module.exports = __webpack_public_path__ + "img/members.649c55f0.svg";